/**
 * ESG Scoring System - Version 1
 * 
 * OFFICIAL VALUES from Backend
 * Source: scoring_max_score-frontend-backend.md
 * Defines maximum score for each ESG question (q06-q41)
 * 
 * Total: 100 points
 * - Environment (E): 40 points
 * - Social (S): 35 points
 * - Governance (G): 25 points
 */

export const SCORE_VERSION = "v1";

/**
 * Maximum SCORE (not points) for each question
 * These are the official values from backend validation
 * Each question has its own max score range: 0 to maxScore
 */
export const QUESTION_MAX_POINTS = {
  // ========================================================================
  // ENVIRONMENT (E)
  // ========================================================================
  q06_ghg_scope_1_2: 3,           // E1.1
  q07_scope_3: 3,                 // E1.2
  q08_reduction_targets: 3,       // E1.3
  q09_renewable_energy: 3,        // E1.4
  q10_waste_policy: 3,            // E2.1
  q11_recycling_rate: 4,          // E2.2
  q12_packaging_reduction: 3,     // E2.3
  q13_supplier_criteria: 4,       // E3.1
  q14_supplier_monitoring: 4,     // E3.2
  q15_water_measurement: 3,       // E4.1
  q16_wastewater: 3,              // E4.2
  q17_green_products: 2,          // E5.1
  q18_certifications: 2,          // E5.2

  // ========================================================================
  // SOCIAL (S)
  // ========================================================================
  q19_regular_contracts: 4,       // S1.1
  q20_health_safety: 4,           // S1.2
  q21_training: 3,                // S1.3
  q22_anti_discrimination: 4,     // S2.1
  q23_diversity: 3,               // S2.2
  q24_child_labor: 4,             // S3.1
  q25_supply_chain_rights: 3,     // S3.2
  q26_community_relations: 3,     // S4.1
  q27_stakeholder_engagement: 2,  // S4.2 (was 3, corrected)
  q28_gdpr: 3,                    // S5.1
  q29_cybersecurity: 2,           // S5.2

  // ========================================================================
  // GOVERNANCE (G)
  // ========================================================================
  q30_ethics_code: 3,             // G1.1
  q31_anti_corruption: 3,         // G1.2
  q32_whistleblowing: 2,          // G1.3
  q33_ownership_structure: 2,     // G2.1
  q34_governance: 2,              // G2.2
  q35_board_diversity: 2,         // G2.3
  q36_regulatory_mapping: 3,      // G3.1
  q37_regulatory_updates: 2,      // G3.2
  q38_financial_statements: 2,    // G4.1
  q39_esg_reporting: 2,           // G4.2
  q40_risk_mapping: 1,            // G5.1 (was 2, corrected)
  q41_incident_response: 1,       // G5.2
};

/**
 * Get maximum points for a specific question
 * @param {string} questionId - Question ID (e.g., "q06_ghg_scope_1_2")
 * @returns {number} Maximum points for the question (0 if not found)
 */
export function getMaxPoints(questionId) {
  return QUESTION_MAX_POINTS[questionId] || 0;
}

/**
 * Total maximum score
 */
export const TOTAL_MAX_SCORE = Object.values(QUESTION_MAX_POINTS).reduce((sum, points) => sum + points, 0);
